import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Phone, Globe, Heart, Book, Users, Shield } from 'lucide-react';
const resources = [{
  category: 'Emergency Helplines (India)',
  icon: Phone,
  color: 'from-red-500 to-pink-500',
  items: [{
    name: 'Childline India',
    contact: '1098',
    description: '24/7 helpline for children and teens in distress - completely free and confidential',
    available: '24/7',
    languages: 'Hindi, English, Regional'
  }, {
    name: 'Women Helpline',
    contact: '181',
    description: 'Support for women facing violence, harassment, or abuse',
    available: '24/7',
    languages: 'Hindi, English'
  }, {
    name: 'Police Emergency',
    contact: '100',
    description: 'Immediate police assistance for emergencies',
    available: '24/7',
    languages: 'All languages'
  }, {
    name: 'National Commission for Women',
    contact: '7827-170-170',
    description: "Women's rights, safety, and legal support",
    available: '10 AM - 6 PM (Mon-Fri)',
    languages: 'Hindi, English'
  }]
}, {
  category: 'Mental Health Support (India)',
  icon: Heart,
  color: 'from-purple-500 to-pink-500',
  items: [{
    name: 'Vandrevala Foundation',
    contact: '1860-2662-345 / 9999-666-555',
    description: 'Free mental health counseling - depression, anxiety, stress, relationships',
    available: '24/7',
    languages: 'Hindi, English, Regional'
  }, {
    name: 'iCall (TISS)',
    contact: '9152-987-821',
    description: 'Psychosocial helpline by trained counselors - completely confidential',
    available: 'Mon-Sat, 8 AM - 10 PM',
    languages: 'Hindi, English, Marathi'
  }, {
    name: 'AASRA',
    contact: '91-22-2754-6669',
    description: 'Suicide prevention and emotional support helpline',
    available: '24/7',
    languages: 'Hindi, English'
  }, {
    name: 'Sneha India (Chennai)',
    contact: '044-2464-0050 / 044-2464-0060',
    description: 'Emotional support, suicide prevention, crisis intervention',
    available: '24/7',
    languages: 'Tamil, English, Hindi'
  }, {
    name: 'Parivarthan (Bangalore)',
    contact: '+91-76-7602-5602',
    description: 'Counseling for youth, relationships, mental health',
    available: 'Mon-Sat, 10 AM - 6 PM',
    languages: 'Kannada, English, Hindi'
  }]
}, {
  category: 'Sexual & Reproductive Health (India)',
  icon: Shield,
  color: 'from-blue-500 to-cyan-500',
  items: [{
    name: 'Love Matters India',
    contact: 'lovematters.in',
    description: 'Stigma-free sex education, relationships, contraception, STIs - in your language',
    available: 'Online',
    languages: 'Hindi, English, Marathi, Bengali'
  }, {
    name: 'TARSHI',
    contact: 'tarshi.net / helpline@tarshi.net',
    description: 'Sexuality, reproductive health, relationships - judgment-free zone',
    available: 'Online + Email',
    languages: 'Hindi, English'
  }, {
    name: 'YP Foundation',
    contact: 'ypfoundation.org',
    description: 'Youth sexual and reproductive rights, LGBTQ+ support',
    available: 'Online',
    languages: 'English, Hindi'
  }, {
    name: 'Population Foundation of India',
    contact: 'populationfoundation.in',
    description: 'Family planning, contraception, reproductive health info',
    available: 'Online',
    languages: 'Hindi, English'
  }, {
    name: 'Marie Stopes India',
    contact: '1800-102-6767',
    description: 'Contraception, family planning, sexual health services',
    available: '9 AM - 6 PM (Mon-Sat)',
    languages: 'Hindi, English, Regional'
  }]
}, {
  category: 'Online Safety & Cyber Crime (India)',
  icon: Globe,
  color: 'from-green-500 to-emerald-500',
  items: [{
    name: 'National Cyber Crime Reporting Portal',
    contact: 'cybercrime.gov.in',
    description: 'Report cyberbullying, harassment, revenge porn, online threats - anonymous option available',
    available: 'Online',
    languages: 'Hindi, English, Regional'
  }, {
    name: 'Cyber Crime Helpline',
    contact: '155260 / 1930',
    description: 'Report cyber crimes, get guidance on online safety',
    available: '24/7',
    languages: 'Hindi, English'
  }, {
    name: 'Cyber Peace Foundation',
    contact: 'cyberpeace.net',
    description: 'Cyberbullying support, digital literacy, online safety',
    available: 'Online',
    languages: 'Hindi, English'
  }]
}, {
  category: 'LGBTQ+ Support (India)',
  icon: Users,
  color: 'from-pink-500 to-purple-500',
  items: [{
    name: 'The Humsafar Trust (Mumbai)',
    contact: '022-2673-3846',
    description: 'LGBTQ+ health, counseling, community support - completely confidential',
    available: 'Mon-Sat, 10 AM - 6 PM',
    languages: 'Hindi, English, Marathi'
  }, {
    name: 'Nazariya (Delhi)',
    contact: 'nazariyaqfrg.com',
    description: 'Queer feminist support, resources, community',
    available: 'Online',
    languages: 'Hindi, English'
  }, {
    name: 'Manas Foundation (Delhi)',
    contact: '011-2656-0405',
    description: 'Mental health support for LGBTQ+ individuals',
    available: 'Mon-Fri, 10 AM - 5 PM',
    languages: 'Hindi, English'
  }, {
    name: 'Sangama (Bangalore)',
    contact: '080-2341-9502',
    description: 'Sexual minorities support, health services',
    available: 'Mon-Sat, 10 AM - 6 PM',
    languages: 'Kannada, English, Hindi'
  }, {
    name: 'Saathii (Mumbai)',
    contact: '022-2300-3800',
    description: 'LGBTQ+ health, rights, community support',
    available: 'Mon-Fri, 10 AM - 5 PM',
    languages: 'Hindi, English, Marathi'
  }]
}, {
  category: 'Educational Resources (India-Specific)',
  icon: Book,
  color: 'from-yellow-500 to-orange-500',
  items: [{
    name: 'Love Matters India',
    contact: 'lovematters.in',
    description: 'Real talk about sex, relationships, and bodies - no judgment, just facts',
    available: 'Online',
    languages: 'Hindi, English, Marathi, Bengali'
  }, {
    name: 'Hidden Pockets',
    contact: 'hiddenpockets.in',
    description: 'Honest conversations about periods, bodies, sexuality in Indian context',
    available: 'Online',
    languages: 'English, Hindi'
  }, {
    name: 'Agents of Ishq',
    contact: 'agentsofishq.com',
    description: 'Sex, love, and desire in India - creative, fun, stigma-free',
    available: 'Online',
    languages: 'Hindi, English'
  }, {
    name: 'Menstrupedia',
    contact: 'menstrupedia.com',
    description: 'Everything about periods - breaking taboos, one period at a time',
    available: 'Online',
    languages: 'Hindi, English, Gujarati'
  }]
}];
export function ResourcesPage() {
  const navigate = useNavigate();
  return <div className="min-h-screen w-full bg-gradient-to-br from-rose-50 to-purple-50" data-id="element-961">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-rose-100" data-id="element-962">
        <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between" data-id="element-963">
          <button onClick={() => navigate('/')} className="flex items-center space-x-2 text-rose-600 hover:text-rose-700" data-id="element-964">
            <ArrowLeft className="w-5 h-5" data-id="element-965" />
            <span className="font-medium" data-id="element-966">Back</span>
          </button>
          <h1 className="text-lg font-bold text-gray-900" data-id="element-967">
            Resources & Support
          </h1>
          <div className="w-20" data-id="element-968" />
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-4 py-8" data-id="element-969">
        <div className="text-center mb-8" data-id="element-970">
          <h2 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-971">
            You're Not Alone
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-972">
            Real help from real people across India. All services are
            confidential, judgment-free, and here for you.
          </p>
          <p className="text-sm text-purple-700 font-medium" data-id="element-973">
            💜 Every helpline here understands Indian culture, speaks your
            language, and respects your privacy
          </p>
        </div>
        {/* Emergency Banner */}
        <div className="mb-8 bg-gradient-to-r from-red-500 to-pink-500 rounded-2xl p-6 text-white shadow-xl" data-id="element-974">
          <div className="flex items-start space-x-4" data-id="element-975">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-976">
              <Phone className="w-6 h-6" data-id="element-977" />
            </div>
            <div data-id="element-978">
              <h3 className="text-xl font-bold mb-2" data-id="element-979">
                खतरे में हो? In Immediate Danger?
              </h3>
              <p className="mb-3" data-id="element-980">
                Call these numbers RIGHT NOW - they're free and available 24/7:
              </p>
              <div className="flex flex-wrap gap-3" data-id="element-981">
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2" data-id="element-982">
                  <p className="text-sm font-medium" data-id="element-983">Police / पुलिस</p>
                  <p className="text-2xl font-bold" data-id="element-984">100</p>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2" data-id="element-985">
                  <p className="text-sm font-medium" data-id="element-986">Childline / चाइल्डलाइन</p>
                  <p className="text-2xl font-bold" data-id="element-987">1098</p>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-lg px-4 py-2" data-id="element-988">
                  <p className="text-sm font-medium" data-id="element-989">
                    Women Helpline / महिला हेल्पलाइन
                  </p>
                  <p className="text-2xl font-bold" data-id="element-990">181</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Resource Categories */}
        <div className="space-y-8" data-id="element-991">
          {resources.map(category => {
          const Icon = category.icon;
          return <div key={category.category} className="bg-white rounded-2xl shadow-lg overflow-hidden" data-id="element-992">
                <div className={`bg-gradient-to-r ${category.color} p-6`} data-id="element-993">
                  <div className="flex items-center space-x-3" data-id="element-994">
                    <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-995">
                      <Icon className="w-6 h-6 text-white" data-id="element-996" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-997">
                      {category.category}
                    </h3>
                  </div>
                </div>
                <div className="p-6" data-id="element-998">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-999">
                    {category.items.map((item, index) => <div key={index} className="border border-gray-200 rounded-xl p-4 hover:border-gray-300 transition-colors" data-id="element-1000">
                        <div className="flex items-start justify-between mb-2" data-id="element-1001">
                          <h4 className="font-bold text-gray-900" data-id="element-1002">
                            {item.name}
                          </h4>
                          <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full" data-id="element-1003">
                            {item.available}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600 mb-2" data-id="element-1004">
                          {item.description}
                        </p>
                        <p className="text-lg font-semibold text-gray-900 mb-1" data-id="element-1005">
                          {item.contact}
                        </p>
                        {item.languages && <p className="text-xs text-purple-600 font-medium" data-id="element-1006">
                            🗣️ {item.languages}
                          </p>}
                      </div>)}
                  </div>
                </div>
              </div>;
        })}
        </div>
        {/* Privacy & Confidentiality Note */}
        <div className="mt-8 bg-purple-50 border border-purple-200 rounded-xl p-6" data-id="element-1007">
          <div className="flex items-start space-x-3" data-id="element-1008">
            <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1009">
              <span className="text-white text-lg" data-id="element-1010">🔒</span>
            </div>
            <div data-id="element-1011">
              <h4 className="font-semibold text-purple-900 mb-1" data-id="element-1012">
                गोपनीयता की गारंटी | Privacy Guaranteed
              </h4>
              <p className="text-sm text-purple-800 mb-2" data-id="element-1013">
                Every helpline here maintains complete confidentiality. They
                won't judge you, they won't tell your parents (unless you're in
                immediate danger), and they won't share your information with
                anyone.
              </p>
              <p className="text-sm text-purple-800 font-medium" data-id="element-1014">
                Asking for help is brave. You deserve support. These people are
                here for YOU.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}